import {pluralize} from "@pg-mono/string-utils";
import {OfferType} from "@pg-rp/common-types";

import {PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT} from "../constants/property_card_detail_overview_content";
import {IPropertyDetailDTO} from "../types/property/IPropertyDetailDTO";
import {getOfferTypeName} from "./get_offer_type_string";

type OfferTypeGender = "feminine" | "masculine" | "neuter";

const roomsAdjectiveFeminine = pluralize([...PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.ROOMS_ADJECTIVE_FEMININE_FORMS]);
const roomsAdjectiveMasculine = pluralize([...PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.ROOMS_ADJECTIVE_MASCULINE_FORMS]);
const roomsAdjectiveNeuter = pluralize([...PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.ROOMS_ADJECTIVE_NEUTER_FORMS]);

const hasKnownPropertyCardDetailOverviewOfferType = (property: IPropertyDetailDTO) => {
    const offerType = property.type || property.offer.type;

    if (offerType === OfferType.FLAT || offerType === OfferType.HOUSE || offerType === OfferType.COMMERCIAL || offerType === OfferType.MODULAR_HOUSE) {
        return true;
    }

    return false;
};

const getPropertyCardDetailOverviewOfferTypeGender = (property: IPropertyDetailDTO): OfferTypeGender => {
    if (!hasKnownPropertyCardDetailOverviewOfferType(property)) {
        return "feminine";
    }

    const offerType = property.type || property.offer.type;

    if (offerType === OfferType.FLAT) {
        const isApartment = property.offer.is_holiday_location || property.offer.is_condohotel;

        return isApartment ? "masculine" : "neuter";
    }

    return "masculine";
};

export const getPropertyCardDetailOverviewRoomsLabel = (property: IPropertyDetailDTO) => {
    const gender = getPropertyCardDetailOverviewOfferTypeGender(property);
    const roomsAdjectiveByGender = {
        feminine: roomsAdjectiveFeminine,
        masculine: roomsAdjectiveMasculine,
        neuter: roomsAdjectiveNeuter
    } as const;

    return `${property.rooms}-${roomsAdjectiveByGender[gender](property.rooms)}`;
};

export function getPropertyCardDetailOverviewOfferTypeName(property: IPropertyDetailDTO): string {
    const offerType = property.type || property.offer.type;

    if (offerType === OfferType.FLAT && (property.offer.is_holiday_location || property.offer.is_condohotel)) {
        return "apartament";
    }

    try {
        return getOfferTypeName(offerType);
    } catch (_error) {
        return PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.UNKNOWN_OFFER_TYPE;
    }
}

export function getPropertyCardDetailOverviewLocationName(property: IPropertyDetailDTO): string {
    const {full_name, name_declension_where} = property.region;

    return name_declension_where || full_name || property.offer.address;
}
import {pluralize} from "@pg-mono/string-utils";
import {OfferType} from "@pg-rp/common-types";

import {PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT} from "../constants/property_card_detail_overview_content";
import {IPropertyDetailDTO} from "../types/property/IPropertyDetailDTO";
import {getOfferTypeName} from "./get_offer_type_string";

type OfferTypeGender = "feminine" | "masculine" | "neuter";

const roomsAdjectiveFeminine = pluralize([...PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.ROOMS_ADJECTIVE_FEMININE_FORMS]);
const roomsAdjectiveMasculine = pluralize([...PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.ROOMS_ADJECTIVE_MASCULINE_FORMS]);
const roomsAdjectiveNeuter = pluralize([...PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.ROOMS_ADJECTIVE_NEUTER_FORMS]);

const hasKnownPropertyCardDetailOverviewOfferType = (property: IPropertyDetailDTO) => {
    const offerType = property.type || property.offer.type;

    if (offerType === OfferType.FLAT || offerType === OfferType.HOUSE || offerType === OfferType.COMMERCIAL || offerType === OfferType.MODULAR_HOUSE) {
        return true;
    }

    return false;
};

const getPropertyCardDetailOverviewOfferTypeGender = (property: IPropertyDetailDTO): OfferTypeGender => {
    if (!hasKnownPropertyCardDetailOverviewOfferType(property)) {
        return "feminine";
    }

    const offerType = property.type || property.offer.type;

    if (offerType === OfferType.FLAT) {
        const isApartment = property.offer.is_holiday_location || property.offer.is_condohotel;

        return isApartment ? "masculine" : "neuter";
    }

    return "masculine";
};

export const getPropertyCardDetailOverviewRoomsLabel = (property: IPropertyDetailDTO) => {
    const gender = getPropertyCardDetailOverviewOfferTypeGender(property);
    const roomsAdjectiveByGender = {
        feminine: roomsAdjectiveFeminine,
        masculine: roomsAdjectiveMasculine,
        neuter: roomsAdjectiveNeuter
    } as const;

    return `${property.rooms}-${roomsAdjectiveByGender[gender](property.rooms)}`;
};

export function getPropertyCardDetailOverviewOfferTypeName(property: IPropertyDetailDTO): string {
    const offerType = property.type || property.offer.type;

    if (offerType === OfferType.FLAT && (property.offer.is_holiday_location || property.offer.is_condohotel)) {
        return "apartament";
    }

    try {
        return getOfferTypeName(offerType);
    } catch (_error) {
        return PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT.UNKNOWN_OFFER_TYPE;
    }
}

export function getPropertyCardDetailOverviewLocationName(property: IPropertyDetailDTO): string {
    const {full_name, name_declension_where} = property.region;

    return name_declension_where || full_name || property.offer.address;
}
